// ─────────────────────────────────────────────────────────────────
// Glass-i — Off-cut register helpers (Stage INVENTORY-OFFCUTS-1).
//
// Pure functions shared by the Off-cuts page: area preview (actual W×H, NO
// CEIL — an off-cut is a real physical remnant) and thickness formatting. The
// server is authoritative for stored area; these only power the live preview.
// ─────────────────────────────────────────────────────────────────

export const SQMT_DIVISOR = 1000000;
export const SQFT_DIVISOR = 92903.04;

export const PERM = Object.freeze({
  VIEW:   'erp.inventory.offcuts.view',
  CREATE: 'erp.inventory.offcuts.create',
  UPDATE: 'erp.inventory.offcuts.update',
  DELETE: 'erp.inventory.offcuts.delete',
  PRINT:  'erp.inventory.offcuts.print'
});

export function hasPermission(me, key) {
  if (!me) return false;
  const list = me.permissions || [];
  return list.includes('*') || list.includes(key);
}

function num(v) { const n = Number(v); return Number.isFinite(n) ? n : 0; }
function round(v, dp) { const f = Math.pow(10, dp); const n = Number(v); return Number.isFinite(n) ? Math.round(n * f) / f : 0; }

// Area from actual width×height in mm (no CEIL). Returns { sqmt, sqft } to 4dp.
export function offcutArea(widthMm, heightMm) {
  const w = num(widthMm), h = num(heightMm);
  if (!(w > 0) || !(h > 0)) return { sqmt: 0, sqft: 0 };
  return { sqmt: round((w * h) / SQMT_DIVISOR, 4), sqft: round((w * h) / SQFT_DIVISOR, 4) };
}

// CLAUDE.md rule 5A — glass area (SQM/SQFT) is ALWAYS displayed at exactly 3 dp
// (Indian grouping). Display-only; underlying values keep full precision.
const AREA_NF3 = new Intl.NumberFormat('en-IN', { minimumFractionDigits: 3, maximumFractionDigits: 3 });
export function formatArea(v) {
  const n = Number(v);
  return Number.isFinite(n) ? AREA_NF3.format(n) : '—';
}

// 12.00 → "12", 5.50 → "5.5" (trim trailing zeros).
export function formatThickness(mm) {
  const n = num(mm);
  if (!n) return '';
  return String(round(n, 2)).replace(/\.0+$/, '').replace(/(\.\d*?)0+$/, '$1');
}

// "600 × 400 mm" — compact dimension label.
export function dimsLabel(widthMm, heightMm) {
  const w = num(widthMm), h = num(heightMm);
  if (!(w > 0) || !(h > 0)) return '';
  return `${round(w, 3)} × ${round(h, 3)} mm`;
}
